/**
 * 客訂結案資格：各產品 PAID SO qty 累計 ≥ order_qty − cancel_qty。
 * 依 Detail `salesOrders[]` 預覽列估算（lines：product／shipQty；可選 customerOrderLineId）。
 */

import {
  getCustomerOrderLineCancelQty,
  getCustomerOrderLineOrderQty,
} from '#/modules/crmMgmt/customerOrder/helper/mapCustomerOrderMeta';

function toFiniteNumber(value) {
  const n = Number(value);
  return Number.isFinite(n) ? n : 0;
}

/** @param {object} [line] */
export function getCustomerOrderLineRequiredQty(line) {
  return Math.max(
    0,
    toFiniteNumber(getCustomerOrderLineOrderQty(line))
      - toFiniteNumber(getCustomerOrderLineCancelQty(line)),
  );
}

/**
 * 加總狀態為 PAID 之銷貨單，對應本 CO 明細的出貨量。
 *
 * @param {object} [detail]
 * @param {object} [line] CO line
 */
export function sumPaidSalesOrderQtyForLine(detail, line) {
  const coLineId = line?.id != null ? String(line.id) : null;
  const productId = line?.product?.id ?? line?.productId ?? null;
  let sum = 0;

  for (const so of detail?.salesOrders ?? []) {
    if (so?.status !== 'PAID') {
      continue;
    }
    for (const soLine of so.lines ?? []) {
      const soCoLineId = soLine?.customerOrderLineId != null
        ? String(soLine.customerOrderLineId)
        : null;
      const soProductId = soLine?.product?.id ?? soLine?.productId ?? null;

      let matched = false;
      if (coLineId && soCoLineId) {
        matched = soCoLineId === coLineId;
      } else if (productId && soProductId) {
        matched = String(soProductId) === String(productId);
      }
      if (!matched) {
        continue;
      }
      sum += toFiniteNumber(soLine?.shipQty ?? soLine?.qty);
    }
  }

  return sum;
}

/**
 * @param {object} [detail]
 * @returns {boolean}
 */
export function isCustomerOrderCloseableByPaidQty(detail) {
  const lines = detail?.lines ?? [];
  if (lines.length === 0) {
    return false;
  }
  return lines.every((line) => {
    const required = getCustomerOrderLineRequiredQty(line);
    return sumPaidSalesOrderQtyForLine(detail, line) >= required;
  });
}
